import { toast } from "react-hot-toast";
import classNames from "classnames";
import { MdOutlineClose } from "react-icons/md";
import { HiLightningBolt } from "react-icons/hi";
import moment from "moment/moment";

export const numberFormat = (value) =>
  new Intl.NumberFormat('en-ID', {
    style: 'currency',
    currency: 'IDR'
  }).format(value);

export const numberFormatWithoutSymbol = (value) =>
  new Intl.NumberFormat('de-DE', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(value)
    .replace("IDR", "")
    .trim();

export function kFormatter(num, precision = 2) {
  const map = [
    { suffix: 'T', threshold: 1e12 },
    { suffix: 'B', threshold: 1e9 },
    { suffix: 'M', threshold: 1e6 },
    { suffix: 'K', threshold: 1e3 },
    { suffix: '', threshold: 1 },
  ];

  const found = map.find((x) => Math.abs(num) >= x.threshold);
  if (found) {
    const formatted = (num / found.threshold).toFixed(precision) + found.suffix;
    return formatted;
  }

  return num;
}


export const timeFormat = (value) => {
  return moment(value).utc().format("HH:mm")
}

export const timeFormatNonUTC = (value) => {
  return moment(value).format("HH:mm")
}

export const formatDate = (value) => {

  try {

    return moment(value).format("DD MMM YYYY");
  } catch (error) {
    return " -- -- ---- "
  }

}

export const containsOnlyNumbers = (str) => {
  return /^\d+$/.test(str);
}



const style = {
  notificationWrapper: "flex flex-row items-center justify-between w-96 bg-green-700 px-4 py-6 text-white shadow-2xl hover:shadow-none transform-gpu translate-y-0 hover:translate-y-1 rounded-xl relative transition-all duration-500 ease-in-out",
  notificationWrapperError: "flex flex-row items-center justify-between w-96 bg-red-800 px-4 py-6 text-white shadow-2xl hover:shadow-none transform-gpu translate-y-0 hover:translate-y-1 rounded-xl relative transition-all duration-500 ease-in-out",
  iconWrapper: " text-xl",
  contentWrapper: "flex flex-grow flex-col items-start justify-center ml-4 cursor-default",
  contentWrapperH1: "text-base text-gray-200 font-semibold leading-none tracking-wider",
  contentWrapperP: "text-sm text-gray-300 mt-2 leading-relaxed tracking-wider",
  closeIcon: "absolute top-2 right-2 cursor-pointer text-lg"
}

export const showToast = (type, title, message) => {
  toast.custom(
    (t) => (
      <div
        className={
          type === "Error" ?
            classNames([
              style.notificationWrapperError,
              t.visible ? "top-0" : "-top-96",
            ])
            :
            classNames([
              style.notificationWrapper,
              t.visible ? "top-0" : "-top-96",
            ])

        }
      >
        <div className={style.iconWrapper}>
          <HiLightningBolt />
        </div>
        <div className={style.contentWrapper}>
          <h1 className={style.contentWrapperH1}>{title}</h1>
          <p className={style.contentWrapperP}>
            {message}
          </p>
        </div>
        <div className={style.closeIcon} onClick={() => toast.dismiss(t.id)}>
          <MdOutlineClose />
        </div>
      </div>
    ),
    { id: "unique-notification", position: "top-center" }
  );
}